export default __webpack_public_path__ + "static/media/No.8-0.d96858b8.jpg";